import { createAction } from "@reduxjs/toolkit";
import type { ExternalTeacherVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveExternalTeacher = createApiThunk<ExternalTeacherVM, string>(
  "educationalAdvisor/externalTeacher/retrieve",
  async (id, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getExternalTeacher(id);
  },
);

export const resetRetrieveExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetRetrieve");
